import { useEffect } from 'react';
export default function useResize(callback) {
  let throttle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
  useEffect(() => {
    let timeout;

    const handleResize = () => {
      clearTimeout(timeout);
      timeout = setTimeout(callback, throttle);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
}